export default {
  formatCurrency(value, currency) {
    if (value == null) {
      return '';
    }
    if (!currency) {
      return value.toFixed(2);
    }
    return Number(value).toLocaleString('de-DE', { style: 'currency', currency });
  }
}
